<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-refresh [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/distributions/mzu')"></med-icon-refresh></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.distributionsMZUFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="LOV ID"
          label="LOV ID"
          [(ngModel)]="filter.distributionsMZU.lovId[0]"
          (ngModelChange)="filter.onLovIdChange($event, 'distributions/mzu')"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="МНН ID"
          label="МНН ID"
          [(ngModel)]="filter.distributionsMZU.mnnId[0]"
          (ngModelChange)="filter.onMnnIdChange($event)"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Номер"
          label="Номер"
          [(ngModel)]="filter.distributionsMZU.number[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-datepicker
          size="small"
          [mode]="'range'"
          label="Дата розподілу"
          placeholder="Дата розподілу"
          [(ngModel)]="filter.distributionsMZU.createdAt"
          (onInput)="filter.distributionsMZUStateChange()"
        ></med-datepicker>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Виконавець"
          label="Виконавець"
          [(ngModel)]="filter.distributionsMZU.executor[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.distributionsMZU.status.length ? 'Всі': 'Обрано фільтрів: ' + filter.distributionsMZU.status.length }}"
          label="Статус"
          [options]="statusTranslatorService.getStatuses()"
          [(ngModel)]="filter.distributionsMZU.status"
          (ngModelChange)="filter.distributionsMZUStateChange()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Напрям"
          label="Напрям"
          [(ngModel)]="filter.distributionsMZU.direction[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Піднапрям"
          label="Піднапрям"
          [(ngModel)]="filter.distributionsMZU.subDirection[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Підписи"
          label="Підписи"
          [(ngModel)]="filter.distributionsMZU.signs[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Номер договору"
          label="Номер договору"
          [(ngModel)]="filter.distributionsMZU.documents[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="МНН"
          label="МНН"
          [(ngModel)]="filter.distributionsMZU.mnn[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Дозування"
          label="Дозування"
          [(ngModel)]="filter.distributionsMZU.dosage[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Торгова назва"
          label="Торгова назва"
          [(ngModel)]="filter.distributionsMZU.tradeName[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Розподілена кількість"
          label="Розподілена кількість"
          [(ngModel)]="filter.distributionsMZU.distributedQuantity[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Одиниця виміру"
          label="Одиниця виміру"
          [(ngModel)]="filter.distributionsMZU.unitOfMeasure[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Вартість за одиницю"
          label="Вартість за одиницю"
          [(ngModel)]="filter.distributionsMZU.price[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Загальна вартість"
          label="Загальна вартість"
          [(ngModel)]="filter.distributionsMZU.totalPrice[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Ставка з ПДВ"
          label="Ставка з ПДВ"
          [(ngModel)]="filter.distributionsMZU.pdv[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Загальна вартість з ПДВ"
          label="Загальна вартість з ПДВ"
          [(ngModel)]="filter.distributionsMZU.totalPdv[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Кількість розвезено"
          label="Кількість розвезено"
          [(ngModel)]="filter.distributionsMZU.delivered[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Сума розвезення з ПДВ"
          label="Сума розвезення з ПДВ"
          [(ngModel)]="filter.distributionsMZU.totalPdv[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Склад"
          label="Склад"
          [(ngModel)]="filter.distributionsMZU.warehouse[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Відмова"
          label="Відмова"
          [(ngModel)]="filter.distributionsMZU.refusal[0]"
          (focusout)="filter.distributionsMZUStateChange()"
        ></med-input>
      </div>
<!--      <div style="width: 100%;">-->
<!--        <med-input-->
<!--          size="small"-->
<!--          [hideClearBtn]="true"-->
<!--          placeholder="Відтермінування"-->
<!--          label="Відтермінування"-->
<!--          [(ngModel)]="filter.distributionsMZU.postponed[0]"-->
<!--          (focusout)="filter.distributionsMZUStateChange()"-->
<!--        ></med-input>-->
<!--      </div>-->
    </div>
  </div>
</p-sidebar>

<app-page-title></app-page-title>

<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div class="table-wrapper" *ngIf="dataService.isMZU()" [hidden]="loadingCounter > 0">
  <p-table
           #distributionMZUTable
           [value]="distributions"
           [tableStyle]="{ 'min-width': '50rem' }"
           styleClass="p-datatable-sm"
           [scrollable]="true"
           scrollHeight="flex"
           [customSort]="true"
           [lazy]="true"
           [resizableColumns]="true"
           columnResizeMode="expand"
           [columns]="tabHeader"
           [reorderableColumns]="true"
           (onColResize)="handleColumnResize($event)"
           (onLazyLoad)="loadData($event, true)"
           (onColReorder)="saveColumnOrder()">

    <ng-template pTemplate="header">
      <tr>
        <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" style="min-width: 10em" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [style.width]="column.width">
            {{ column.label }}&nbsp;
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr class="table-content-text" (dblclick)="goToDistribution(row['distributionId'])">
        <ng-container *ngFor="let col of columns">
        <td class="h10-text black-80" *ngIf="col.key === 'lovId'">
            {{row['lovId']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'mnnId'">
          {{row['mnnId']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'id'">
          <a (click)="goToDistribution(row['distributionId'])" style="cursor: pointer">
            {{row['orderName']}}
          </a>
        </td>

        <td class="h10-text black-80"  *ngIf="col.key === 'orderDate'">
          {{row['createdAt'] | date: 'dd.MM.yyyy'}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'originalAuthorName'">
          {{row['executor']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'status'">
          <div class="h10-text" style="display: flex; flex-direction: row; width: 18em"><img [src]="getPathToStatusImg(row['status'])" width="4" height="16" style="vertical-align: middle;" />&nbsp; {{statusTranslatorService.getStatusForString(row['status'])}}</div>
        </td>

        <td class="h10-text black-60" *ngIf="col.key === 'direction'">
          <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('direction')">
                        <span [pTooltip]="tooltipContent">
                            {{row['direction']}}
                        </span>
          </div>
          <ng-template #tooltipContent>
            <div class="flex items-center h10-text">
              {{row['direction']}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'subDirection'">
          <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('subDirection')">
                        <span [pTooltip]="tooltipSubDirection">
                            {{row['subDirection']}}
                        </span>
          </div>
          <ng-template #tooltipSubDirection>
            <div class="flex items-center h10-text">
              {{row['subDirection']}}
            </div>
          </ng-template>
        </td>

        <td *ngIf="col.key === 'signs'">
          <div class="flex">
          <med-bubble
            [styleClass]="'med-bubble-dark-purple'">
            <div class="h10-text" *ngIf="row.signs">
              <span style="color: #fff">{{row.signs.split('~~')[0]}}</span>
              <span style="color: #c7c7c7">/{{row.signs.split('~~')[1]}}</span>
            </div>
          </med-bubble>
          </div>
        </td>

        <td class="h10-text" *ngIf="col.key === 'agreementNumber'">
          <a href="#">1231231_1231</a> (m)
        </td>

        <td *ngIf="col.key === 'mnn'">
          <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('mnn')" *ngIf="col.key === 'mnn'">
                        <span [pTooltip]="tooltipMnn">
                          {{row.mnn}}
                        </span>
          </div>
          <ng-template #tooltipMnn >
            <div class="flex items-center h10-text">
              {{row.mnn}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'dosage'">
          {{row['dosage']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'tradeName'">
          <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('tradeName')">
                        <span [pTooltip]="tooltipTradeName">
                          {{row.tradeName}}
                        </span>
          </div>
          <ng-template #tooltipTradeName >
            <div class="flex items-center h10-text">
              {{row['tradeName']}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'distributedQuantity'">
          {{row['distributedQuantity']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'measure'">
          {{row['unitOfMeasure']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'unitPrice'">
          {{row['price']}}
        </td>

        <td class="h10-text black-80"  *ngIf="col.key === 'totalPrice'">
          {{row['totalPrice']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'pdv'">
          {{ getVatRate(row['pdv'])}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'totalPriceWithPDV'">
          {{row['totalPdv']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'deliveredQuantity'">
          {{row['delivered']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'totalDeliveredPriceWithPDV'">
          {{row['priceOfDeliveredWithPdv']}}
        </td>

<!--        <td class="h10-text black-80" *ngIf="col.key === 'deliveredAndDistributed'">-->
<!--          <p-progressBar aria-labelledby="label_status2" [value]="50"></p-progressBar>-->
<!--          <div id="label_status2" class="h10-text flex flex-between">-->
<!--            <div>-->
<!--              16/32-->
<!--            </div>-->
<!--            <div>-->
<!--              50%-->
<!--            </div>-->
<!--          </div>-->
<!--        </td>-->

        <td class="h10-text black-80" *ngIf="col.key === 'warehouseName'">
          {{row['warehouse']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === '4'">
          <div class="h10-text" style="display: inline-flex" *ngIf="row['refusal']"><img [src]="getPathToRefusalImg(row['refusal'])" width="4" height="16" style="vertical-align: middle;"/>&nbsp; {{row['refusal']}}</div>
        </td>

<!--        <td class="h10-text black-80" *ngIf="col.key === 'until'">-->
<!--          13.06.2025-->
<!--        </td>-->
      </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex flex-center flex-between">
        <med-pagination
          [total]="totalRows"
          [page]="selectedPageNumber"
          [perPage]="pageSize"
          (pageChange)="pageChange($event)"
        ></med-pagination>

        <div class="small-text">
          Показано &nbsp;<strong>{{ getFirstShowedRowIndex() }}</strong>-<strong>{{ getFirstShowedRowIndex() + pageSize }}</strong> &nbsp;з {{ totalRows }}
        </div>

        <div>
          <span class="small-text">Кількість на сторінку</span>
          <med-radio-group
            mode="buttons"
            [value]="totalRows"
            [options]="paginationOptions"
            (onInput)="pageSizeChanged($event)"
          ></med-radio-group>
        </div>
      </div>
    </ng-template>

  </p-table>
</div>
